import React from "react";

import { Paper } from "@material-ui/core";

import { i18n } from "../../translate/i18n";
import TabPanel from "../TabPanel";
import SchedulesForm from "../SchedulesForm";

/**
 * Tab "Horários" — formulário de horários de atendimento da conexão.
 * Compartilhada entre WhatsAppModal (nativo) e PluginConnectionModal.
 * Estado `schedules` e handler `handleSaveSchedules` vêm por props (não estão no Formik).
 */
const SchedulesTab = ({ tab, classes, schedules, handleSaveSchedules }) => {
  return (
    <TabPanel className={classes.container} value={tab} name="schedules">
      {tab === "schedules" && (
        <Paper style={{ padding: 20 }}>
          <SchedulesForm
            loading={false}
            onSubmit={handleSaveSchedules}
            initialValues={schedules}
            labelSaveButton={i18n.t("whatsappModal.buttons.okAdd")}
          />
        </Paper>
      )}
    </TabPanel>
  );
};

export default SchedulesTab;
